export default "__VITE_ASSET__CjtMN72Q__"